export default {
  state: {
    popupActivities: {
      addMark: false,
      addMedia: false,
      addPage: false,
      share: false,
    },
  },
  getters: {},
  mutations: {
    openPopup(state, payload) {
      state.popupActivities[payload] = true;
    },
    closePopup(state, payload) {
      state.popupActivities[payload] = false;
    },
  },
};
